export const successToast = () => {
    return {
                appearance: 'success',
                autoDismiss: true,
            }
}

export const infoToast = () => {
    return {
        appearance: 'info',
        autoDismiss: true,
    }
}

export const warningToast = () => {
    return {
        appearance: 'warning',
        autoDismiss: true,
    }
}

export const errorToast = () => {
    return {
        appearance: 'error',
        autoDismiss: true,
    }
}